import React, { useMemo, useRef, useState } from "react";
import styles from '../styles/walletMenu.module.scss'
import { useNavigate } from "react-router";
import { useModal } from "@/modals/modalContext";
import { useTranslation } from "react-i18next";
import Icon from "@/wmCompoments/Icon";
import { IconName } from "@/wmCompoments/Icon/iconTypes";

const WalletMenu = ({data}) => {
  const navigate = useNavigate()
  const { t } = useTranslation('centralWallet')
  const { openModal } = useModal()

  const items = useMemo(() => {
      return [
        {
          icon: 'icon-wallet-deposit',
          title: t('deposit'),
          onClick: ()=>{
            openModal('topup')
            },
        },
        {
          icon: 'icon-wallet-transfer',
          title: t('transfer'),
          onClick: () => {navigate('/mine/transferCenter')}
        },
        {
          icon: 'icon-wallet-withdraw',
          title: t('withdraw'),
          onClick: ()=>{
            openModal('withdraw')
            },
        },
        {
          icon: 'icon-wallet-account',
          title: t('accountManagement'),
          onClick: () => {navigate('/mine/accountManagement')}
        }
      ]
    }, [openModal, openModal])

  return <div className={styles.walletMenu}>
    <div className={styles.title}>
        <div className={styles.left}>
            <div className={styles.text}>{(t('mainWalletRMB'))}</div>
            <div className={styles.balance}>
              <Icon name='icon-mine-wallet' className={styles.wallet_icon}  />
              <span>{data?.centerWalletBalance ?? "0.0"}</span>
            </div>
        </div>
        <div className={styles.right} onClick={()=>{navigate('/mine/walletExchange')}}>
            <Icon name='icon-wallet-exchange' className={styles.exchange_icon} />
            <span>{t('exchange')}</span>
        </div>
    </div>

    <div className={styles.line}></div>

    <div className={styles.menu}>
      {items.map((v,index)=>{
        return <div key={index} className={styles.item} onClick={v.onClick} >
          <Icon name={v.icon as IconName} className={styles.item_icon} />
          <span>{v.title}</span>
        </div>
      })}
    </div>
  </div>
}

export default WalletMenu